export const MODAL_BG = '#222B36';
export const SURFACE_BG = '#34404D';
export const GREEN = '#26A69A';
export const RED = '#923E4A';
export const ORANGE = '#928f3e';
